import { render, staticRenderFns } from "./Counters.vue?vue&type=template&id=02b8725c&"
import script from "./Counters.vue?vue&type=script&lang=ts&"
export * from "./Counters.vue?vue&type=script&lang=ts&"
import style0 from "./Counters.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports